<template>
  <dialog-employee-terms lazy />
  <dialog-forgot-password />
  <dialog-interests lazy />
  <dialog-klarna lazy />
  <!-- This z-index is +1 higher than the cookie popup. We want this popup to show on top of the cookie popup -->
  <dialog-location-confirmation hide-close-button />
  <dialog-loyalty-sign-up />
  <dialog-marketing-enrollment />
  <dialog-mini-cart />
  <dialog-quickshop />
  <dialog-profile-enrichment />
  <dialog-sign-in />
  <dialog-sign-in-confirmation lazy :size="{ sm: 'full', md: 'md' }" />
  <dialog-sign-up />
  <dialog-three-ds-challenge disable-outside-interaction hide-close-button />
  <dialog-welcome />
  <!-- TODO: Cleanup once the experiment associated with epic GLOBAL15-108782 is complete. -->
  <dialog-language-preference hide-close-button />
</template>

<script lang="ts" setup>
const {
  DialogEmployeeTerms,
  DialogForgotPassword,
  DialogInterests,
  DialogKlarna,
  DialogLanguagePreference, // Experiments
  DialogLocationConfirmation,
  DialogLoyaltySignUp,
  DialogMarketingEnrollment,
  DialogMiniCart,
  DialogQuickshop,
  DialogProfileEnrichment,
  DialogSignIn,
  DialogSignInConfirmation,
  DialogSignUp,
  DialogThreeDsChallenge,
  DialogWelcome
} = useDialogsStore()
</script>
